import type { ChangeEvent, InputHTMLAttributes } from 'react';

import { ErrorMessage } from '@components/Forms';
import { EStyles } from '@enums/style.enum';
import { RegExPatterns } from '@utils/RegExPatterns';

import classes from './Input.module.scss';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: string;
	onTextChange?: (value: string) => void;
	numbersAndLettersOnly?: boolean;
	numbersOnly?: boolean;
	maxLength?: number;
	displayError?: boolean;
}

export const Input: React.FC<InputProps> = ({
	label,
	id,
	error,
	onTextChange,
	numbersAndLettersOnly = false,
	numbersOnly = false,
	maxLength,
	displayError = true,
	...props
}: React.PropsWithChildren<InputProps>) => {
	const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (numbersAndLettersOnly) {
			e.target.value = e.target.value.replace(RegExPatterns.onlyNumbersAndLetters, EStyles.emptyQuote);
		} else if (numbersOnly) {
			e.target.value = e.target.value.replace(RegExPatterns.onlyNumbers, EStyles.emptyQuote);
		}
		props.onChange?.(e);
		onTextChange?.(e.target.value);
	};

	return (
		<div className={classes['inputContainer']}>
			{label && (
				<label htmlFor={id} className={classes['label']}>
					{label}
				</label>
			)}
			<input
				id={id}
				className={`${classes['input']} ${!error ? EStyles.emptyQuote : classes['error']}`}
				autoCorrect={EStyles.off}
				spellCheck={EStyles.false}
				onChange={_onChange}
				maxLength={maxLength ? maxLength : undefined}
				{...props}
			/>
			{displayError && <ErrorMessage error={error} visible={!!error} />}
		</div>
	);
};
